import React, { createContext, useContext, useState, ReactNode } from 'react';

interface DebugContextType {
  showPrerequisitesDebug: boolean;
  setShowPrerequisitesDebug: (show: boolean) => void;
}

const DebugContext = createContext<DebugContextType | undefined>(undefined);

export const useDebug = () => {
  const context = useContext(DebugContext);
  if (context === undefined) {
    throw new Error('useDebug must be used within a DebugProvider');
  }
  return context;
};

interface DebugProviderProps {
  children: ReactNode;
}

export const DebugProvider: React.FC<DebugProviderProps> = ({ children }) => {
  const [showPrerequisitesDebug, setShowPrerequisitesDebug] = useState(false);

  const value: DebugContextType = {
    showPrerequisitesDebug,
    setShowPrerequisitesDebug,
  };

  return (
    <DebugContext.Provider value={value}>
      {children}
    </DebugContext.Provider>
  );
};
